(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4238],{

/***/ 49962:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/wifi-networks",
      function () {
        return __webpack_require__(87482);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_components_WifiNetworks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61539);


const Page = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WifiNetworks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            type: "google-cloud"
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,518,2862,770,6664,210,8863,6853,5294,2202,3841,5983,3769,1539,9774,2888,179], function() { return __webpack_exec__(49962); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);